import React from 'react';

function Divider(props) {

    return(
        <div className="row mt-4 mb-4">
            <div className="col-lg-12">
                <h3 className="font-weight-bold text-black">{props.title}</h3>
            </div>
        </div>
    );
}

export default Divider;